/**
 * Opens a player's Telegram profile (not any in-game profile screen — this app
 * has no such feature). No-ops when the player has no username set, since
 * there is no way to deep-link to a Telegram profile without one.
 */
export function openTelegramProfile(username: string | null | undefined): void {
  if (!username) return;
  const url = `https://t.me/${username}`;
  const webApp = window.Telegram?.WebApp;
  if (webApp?.openTelegramLink) {
    webApp.openTelegramLink(url);
    return;
  }
  // Non-Telegram/dev-browser fallback (no WebApp bridge available).
  window.open(url, '_blank', 'noopener,noreferrer');
}
